angular
    .module('app')
    .component('b2bPartnersAdd', {
        templateUrl: '/templates/pages/b2bPartners/b2bPartnersAdd/b2bPartnersAdd.html',
        controller: 'B2bPartnersAddController',
        controllerAs: 'vm',
    });